// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import SimpleSelect from '../utils/FormWidgets/SimpleSelect';

export class TagForm extends React.PureComponent {
  changeTag = (value, tag) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { changeType } = this.props;
    changeType(tag, value);
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { tag, width } = this.props;
    return (
      <div style={{ width: width || '200px' }}>
        <SimpleSelect
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          onChange={this.changeTag}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          value={tag.type}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          name={tag.name}
          data={[
            { value: 'normal', label: 'normal' },
            { value: 'marketplace filter', label: 'marketplace filter' },
            {
              value: 'additional booking info',
              label: 'additional booking info',
            },
            { value: 'hidden', label: 'hidden' },
          ]}
        />
      </div>
    );
  }
}
